/**
  *
  * Usage:
  *
  *   data-sw-product-discoverability
  *
  *
  */
 
var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-product-discoverability]').each(function() {
    var $el = $(this);

    require(['js/lib/views/ProductDiscoverability', 'js/lib/models/ModelManager'], function(ProductDiscoverability, ModelManager) {
      var spin = $el.data('swProductDiscoverability');

      new ProductDiscoverability({
        model:  ModelManager.getProductDiscoverability(spin),
        el:     $el
      });
    });
  });

};